module.exports = __webpack_public_path__ + "media/bom/digikey-653b69dc.png";